// Production Environment Configuration
// This file is used for production builds

export const environment = {
  production: true,
  apiUrl: 'https://live-translator-api-714048340715.us-central1.run.app',
  enableConsoleLog: false,
  auth0: {
    domain: 'dev-2hjdm0qn6otliqls.us.auth0.com',
    clientId: 'Xg3Gxsm7YIddHVkM1yohO76kADkfN4Qa', // Production Auth0 Client ID
    audience: 'https://dev-2hjdm0qn6otliqls.us.auth0.com/api/v2/',
  },
  firebase: {
    apiKey: 'AIzaSyAH8hiC4dNowG3i_CCF7SnWgRak9hOPof0',
    authDomain: 'translation-5c1b8.firebaseapp.com',
    projectId: 'translation-5c1b8',
    storageBucket: 'translation-5c1b8.firebasestorage.app',
    messagingSenderId: '714048340715',
    appId: '1:714048340715:web:5d317f4dc03ff6c5a1f4ae',
    measurementId: 'G-GVCVSLHC8J',
  },
};


